var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8885 3.92498C24.6984 3.81527 24.4829 3.75752 24.2635 3.75752C24.044 3.75752 23.8285 3.81527 23.6385 3.92498L13.001 9.82498L2.36347 3.91248C2.17342 3.80565 1.95873 3.75039 1.74072 3.75218C1.52271 3.75397 1.30896 3.81274 1.12068 3.92268C0.932411 4.03261 0.776163 4.18987 0.667453 4.37885C0.558743 4.56784 0.501352 4.78196 0.500977 4.99998V17.5C0.500977 18.163 0.764368 18.7989 1.23321 19.2677C1.70205 19.7366 2.33793 20 3.00097 20H23.001C23.664 20 24.2999 19.7366 24.7687 19.2677C25.2376 18.7989 25.501 18.163 25.501 17.5V4.99998C25.5009 4.78305 25.4444 4.56987 25.337 4.38139C25.2296 4.19291 25.0751 4.03562 24.8885 3.92498Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 5.00412H1.00004V4.99999V2.5C1.00004 1.96957 1.21076 1.46086 1.58583 1.08579C1.9609 0.710713 2.46961 0.5 3.00004 0.5H23C23.5305 0.5 24.0392 0.710714 24.4142 1.08579C24.7893 1.46086 25 1.96956 25 2.5V4.99999H24.9999L25.0001 5.00985C25.0027 5.14254 24.9701 5.27354 24.9055 5.3895C24.8419 5.50368 24.7497 5.59923 24.6378 5.66673L13.3986 11.9107C13.2797 11.9737 13.1471 12.0067 13.0125 12.0067C12.8779 12.0067 12.7454 11.9737 12.6265 11.9107L1.38253 5.66412C1.38221 5.66395 1.3819 5.66377 1.38159 5.6636C1.26505 5.59787 1.1682 5.50216 1.1011 5.38639C1.03382 5.2703 0.998918 5.13829 1.00003 5.00412Z",
    fill: "#0057FF",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailHover);
export default __webpack_public_path__ + "static/media/emailHover.d1c97bed2164819e1380d5175e081971.svg";
export { ForwardRef as ReactComponent };